import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

//TODO @samanshahmohamadi refactor this
export const icon: SxStyleFunc<boolean | undefined> = (disabled) => ({
  cursor: disabled ? 'default' : 'pointer',
  ...(disabled
    ? {}
    : {
        '&:hover': {
          color: (p) => p.palette.grey[700],
        },
        '&:hover svg': {
          color: (p) => p.palette.grey[700],
        },
      }),
});
